<template>
  <v-container
    class="pa-2 grey lighten-4"
    fluid
    v-if="items.length"
  >
    <v-layout row>
      <v-flex grow>
        <v-list
          two-line
          class="pa-0 attachment-list"
        >
          <template v-for="(item, index) in items">
            <v-subheader
              v-if="item.header"
              :key="item.header"
            >
              {{ item.header }}
            </v-subheader>

            <v-divider
              v-else-if="item.divider"
              :key="index"
              :inset="item.inset"
            ></v-divider>

            <v-list-tile
              v-else
              :key="`${item.title}${index}`"
              avatar
            >
              <v-list-tile-avatar v-if="item.avatar">
                <img :src="item.avatar">
              </v-list-tile-avatar>

              <v-list-tile-avatar v-if="item.icon">
                <v-icon :class="[item.iconClass]">{{ item.icon }}</v-icon>
              </v-list-tile-avatar>

              <v-list-tile-content>
                <v-list-tile-title v-html="item.title"></v-list-tile-title>
                <v-list-tile-sub-title v-html="item.subtitle" v-if="item.status !== 'upload-error'"></v-list-tile-sub-title>
                <v-list-tile-sub-title v-else><span class="error--text">אירעה שגיאה</span></v-list-tile-sub-title>
              </v-list-tile-content>

              <v-list-tile-action>
                <v-btn
                  flat
                  icon
                  @click="deleteFile(item.serverFilename, item.bucket)"
                >
                  <v-icon>delete</v-icon>
                </v-btn>
              </v-list-tile-action>
            </v-list-tile>
          </template>
        </v-list>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  data() {
    return {
      // items: [
      // {
      //   avatar: "https://cdn.vuetifyjs.com/images/lists/1.jpg",
      //   title: "IMG_4333.jpg",
      //   subtitle: "100%"
      // },
      // { divider: true, inset: false },
      // {
      //   icon: "image",
      //   iconClass: "blue white--text",
      //   title: "IMG_0123.jpg",
      //   subtitle: "97.8%"
      // },
      // ]
    };
  },

  computed: {
    images() {
      let images = this.$store.getters["uploader/files"](this.imagesBucket);
      if (images) {
        return images.map(item => {
          console.log(item)
          return {
            icon: "image",
            iconClass: "blue white--text",
            title: item.filename,
            subtitle: parseInt(item.upload.progress) + '%',
            serverFilename: item.upload.filename,
            bucket: this.imagesBucket,
            status: item.status
          };
        });
      } else {
        return [];
      }
    },
    files() {
      let files = this.$store.getters["uploader/files"](this.filesBucket);
      if (files) {
        return files.map(item => {
          console.log(item)
          return {
            icon: "attachment",
            iconClass: "red white--text",
            title: item.filename,
            subtitle: parseInt(item.upload.progress) + '%',
            serverFilename: item.upload.filename,
            bucket: this.filesBucket,
            status: item.status
          };
        });
      } else {
        return [];
      }
    },
    items() {
      return this.images.concat(this.files);
    }
  },

  methods: {
    deleteFile(filename, bucket) {
      console.log(filename, bucket);
      this.$store.commit('uploader/DELETE_FILE', { filename, bucket })
    }
  },

  props: ["imagesBucket", "filesBucket"],

  beforeDestroy() {},

  components: {}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.attachment-list {
  max-height: 200px;
  overflow: auto;
}
</style>



// WEBPACK FOOTER //
// src/components/chat/InputAttachments.vue